import {onMounted, type Ref, ref} from "vue";

export interface SearchParam {
  readonly search: Ref<string>
  readonly searchInput: Ref<string>
  readonly submitSearch: () => void
}

export function useSearchParam(state: Ref<string>): SearchParam {
  const inputState = ref('')

  onMounted(() => inputState.value = state.value)
  const submitSearch = () => state.value = inputState.value

  return {search: state, searchInput: inputState, submitSearch}
}
